import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  getCustomiseOptions,
  selectCustomisePlateOptions,
} from "@/pages/CheckoutInfo/checkoutInfoSlice";
import React, { useEffect, useRef } from "react";
import { CardRadioGroup } from "@/components/basic/CardRadioGroup/CardRadioGroup";

const titleMap = {
  font: "Choose Font",
  logo: "Choose Flag",
  border: "Choose Border",
  size: "Choose Size",
};

const nameMap = {
  font: "digit_style",
  logo: "euro",
  border: "border",
  size: "plate_size",
};

type Props = {
  isCustomPlate: boolean;
  setFieldValue: Function;
  registration: string;
  values: {
    font?: string;
    logo?: string;
    border?: string;
    size?: string;
    [key: string]: any;
  };
};

export const CustomisePlate = ({
  isCustomPlate,
  values,
  setFieldValue,
  registration,
}: Props) => {
  const hadInitValues = useRef(false);
  const hadSetValues = useRef(false);
  const options = useAppSelector(selectCustomisePlateOptions);
  const dispatch = useAppDispatch();

  const getPriceFieldName = (name: string) => {
    let key = name;
    if (key === "logo") {
      key = "background";
    }
    return `acrylic_plate_${key}`;
  };

  useEffect(() => {
    if (!options) {
      dispatch(getCustomiseOptions());
    }
  }, [options]);

  useEffect(() => {
    if (options && !hadSetValues.current) {
      if (isCustomPlate) {
        hadSetValues.current = true;
      } else if (hadInitValues.current) {
        return;
      }

      for (let key in options) {
        if (!values[nameMap[key]]) {
          setFieldValue(
            nameMap[key],
            isCustomPlate ? Object.values(options[key])[0].name : ""
          );
          setFieldValue(
            getPriceFieldName(key),
            isCustomPlate ? Object.values(options[key])[0].price : 0
          );
        }
      }
      hadInitValues.current = true;
    }
  }, [values, options, isCustomPlate]);

  // TODO should remove values when don't customise plate?

  return (
    <div className="flex-column">
      {options &&
        Object.entries(options).map(([name, option], index, arr) => {
          const radios = Object.values(option);
          const key = nameMap[name];
          return (
            <React.Fragment key={key}>
              <h2 className="text-center my-4">{titleMap[key]}</h2>
              <CardRadioGroup
                value={values[key]}
                radios={radios}
                name={key}
                renderContent={(renderOption: { name: any; price: string }) => {
                  const img = require(`@/assets/img/customisePlateOptions/${name}/${renderOption.name}.png`);
                  return (
                    <div className="flex-column p-2">
                      <img src={img} alt={`${renderOption.name}`}></img>
                      <p className="mb-2 text-sm">£{renderOption.price}</p>
                    </div>
                  );
                }}
                onChange={(e, option) => {
                  const value = (e.target as HTMLInputElement).value;
                  setFieldValue(key, value);
                  setFieldValue(getPriceFieldName(key), option.price);
                }}
                wrapperClassName={`flex flex-wrap justify-center ${
                  name !== "logo" ? (radios.length > 1 ? "gap-4" : "") : "gap-2"
                } `}
                optionClassName={`!bg-white md:w-20 w-20`}
              ></CardRadioGroup>
              {index !== arr.length - 1 && (
                <hr className="my-2 h-px border-none bg-black/10" />
              )}
            </React.Fragment>
          );
        })}
      <div
        className={`${
          values[nameMap["size"]]?.toLowerCase() !== "motorbike"
            ? "grid grid-cols-2"
            : ""
        } grid mt-8 items-center justify-center`}
      >
        {values[nameMap["size"]]?.toLowerCase() !== "motorbike" ? (
          <img
            src={`https://${
              window.location.host
            }/reg.php?&reg=${registration}&font=${values[
              nameMap["font"]
            ]?.toLowerCase()}&logo=${values[
              nameMap["logo"]
            ]?.toLowerCase()}&border=${values[
              nameMap["border"]
            ]?.toLowerCase()}&size=${
              values[nameMap["size"]]?.toLowerCase() === "square"
                ? "large"
                : values[nameMap["size"]]?.toLowerCase()
            }-front`}
            alt="Front Number Plate from New Reg"
            className="md:col-span-1 col-span-full max-h-40"
          ></img>
        ) : (
          <></>
        )}
        <img
          src={`https://${
            window.location.host
          }/reg.php?reg=${registration}&font=font=${values[
            nameMap["font"]
          ]?.toLowerCase()}&logo=${values[
            nameMap["logo"]
          ]?.toLowerCase()}&border=${values[
            nameMap["border"]
          ]?.toLowerCase()}&size=${values[
            nameMap["size"]
          ]?.toLowerCase()}-back`}
          alt="Rear Number Plate from New Reg"
          className="md:col-span-1 col-span-full max-h-40"
        ></img>
      </div>
    </div>
  );
};
